import React, { useContext } from 'react'
import { Box, Typography } from '@mui/material'
import { SectionContext } from '../Section/Context'

export const SectionContentMarketCityHeader: React.FunctionComponent<{
  title: string
  state: string
}> = ({ title, state }) => {
  const { theme } = useContext(SectionContext)

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          flex: 1,
        }}
      >
        <Typography
          sx={{
            borderRadius: '2px',
            fontSize: '0.875rem',
            padding: '2px 4px',
            backgroundColor: (theme) => theme.app.neon,
          }}
          variant="button"
        >
          {state}
        </Typography>
        <Typography
          variant="t1"
          component="h1"
          sx={{
            color: theme === 'dark' ? 'primary.contrastText' : 'textPrimary',
            textTransform: 'uppercase',
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  )
}
